import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { askToRetry, isRetryableError } from "../utils/networkErrorBus";

class AxiosApiService {
    // Runs a request, and on a "no response" or server-side failure, offers the user a retry.
    private async request<T>(perform: () => Promise<AxiosResponse<T>>): Promise<T | null> {
        while (true) {
            try {
                const response = await perform();
                return response.data;
            } catch (error) {
                if (isRetryableError(error) && (await askToRetry())) {
                    continue;
                }
                return null;
            }
        }
    }

    public async postAsync<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T | null> {
        return this.request<T>(() => axios.post<T>(url, data, config));
    }
    public async getAsync<T>(url: string, config?: AxiosRequestConfig): Promise<T | null> {
        return this.request<T>(() => axios.get<T>(url, config));
    }

    public async putAsync<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T | null> {
        return this.request<T>(() => axios.put<T>(url, data, config));
    }
    public async deleteAsync<T>(url: string, config?: AxiosRequestConfig): Promise<T | null> {
        return this.request<T>(() => axios.delete<T>(url, config));
    }
}

export default AxiosApiService;